import React from 'react';
import { motion } from 'framer-motion';

const NotFoundPage = () => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="h-screen flex flex-col justify-center items-center bg-secondary text-primary"
        >
            <motion.h1
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="text-6xl font-bold font-playfair-display"
            >
                404
            </motion.h1>
            <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.4, delay: 0.4 }}
                className="text-lg font-nunito-sans"
            >
                It seems like you've lost your way.
            </motion.p>
            <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                className="flex gap-4 mt-6"
            >
                <a
                    href="/"
                    className="px-6 py-3 bg-primary text-accent rounded-md font-nunito-sans text-lg hover:bg-secondary transition"
                >
                    Back Home
                </a>
                <a
                    href="/contact"
                    className="px-6 py-3 bg-primary text-accent rounded-md font-nunito-sans text-lg hover:bg-secondary transition"
                >
                    Contact Us
                </a>
            </motion.div>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.8 }}
                className="mt-12"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 100 100"
                    className="w-24 h-24 animate-spin"
                >
                    <circle
                        cx="50"
                        cy="50"
                        r="45"
                        stroke="#223843"
                        strokeWidth="5"
                        fill="none"
                    />
                </svg>
            </motion.div>
        </motion.div>
    );
};

export default NotFoundPage;
